import InitCancelLogic from "./Cancel.logic";

const CancelComponent: React.FC = () => {
    const { selectedClients, clients, data, onCancel, onChange, addClient, removeSelectedClient } = InitCancelLogic();
    return (
        <div className="page-container">
            <h1 className="text-align-center">Otkaži sve treninge klijentu</h1>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <button className="btn-danger" type="button" onClick={onCancel}>Otkaži</button>

                <div>
                    <label htmlFor="client">Pretraga klijenata</label>
                    <input placeholder="Traži po imenu ili prezimenu..." id="client" type={"text"} value={data.client} onChange={onChange} name="client"></input>
                </div>
            </div>

            {selectedClients.length > 0 && (
                <div className="card" style={{ marginTop: '16px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {selectedClients.map((c) =>
                            <button className="btn-secondary" type="button" key={c.id} onClick={() => removeSelectedClient(c)}>{c.firstName} {c.lastName}</button>
                        )}
                    </div>
                </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '12px' }}>
                {clients.map((c) => c.firstName.concat(" ", c.lastName).toLowerCase().replaceAll("ć", "c").replaceAll("č", "c").replaceAll("š", "s").replaceAll("ž", "z").replaceAll("đ", "dj").includes(data.client.toLowerCase().replaceAll("ć", "c").replaceAll("č", "c").replaceAll("š", "s").replaceAll("ž", "z").replaceAll("đ", "dj")) ? (
                    <button type="button" key={c.id} onClick={() => addClient(c)}>{c.firstName} {c.lastName}</button>
                ) : "")
                }
            </div>

            <div style={{ marginTop: '16px' }}>
                <button className="btn-danger" type="button" onClick={onCancel}>Otkaži</button>
            </div>
        </div>
    );
}

export default CancelComponent;
